import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { catchError } from 'rxjs';
import { TabsService } from '../../../../shared/components/tabs/tabs.service';
import { Button, CurrentTab, PopUpTitles, RoutePath } from '../../../../shared/model/enum';
import { Result } from '../../../../shared/model/response.model';
import { CommonService } from '../../../../shared/services/common.service';
import { CodeCrosswalkService } from '../../../admin/code-crosswalk/code-crosswalk.service';
import { ActivityTabService } from '../../../crm/companies/pages/company-info-tabs/activity-tab/activity-tab.service';
import { ImportCompanyVM, ImportModel } from '../../../crm/companies/pages/companies/companies.model';
import { CompaniesService } from '../../../crm/companies/pages/companies/companies.service';
import { CommonDropdownModel } from '../../../crm/companies/pop-ups/add-company/add-company.model';
import { CrmService } from '../../../crm/crm.service';
import { InsertUpdateImportDocumnets, TemplateData } from '../../import-documents.model';
import { ImportDocumentsService } from '../../import-documents.service';
import { ProgressHelperService } from '../step-progressbar/progress-helper.service';

@Component({
  selector: 'app-import-tab',
  templateUrl: './import-tab.component.html',
  styleUrls: ['./import-tab.component.scss']
})
export class ImportTabComponent implements OnInit {
  // Enums & Navigation Definitions
  enumPopUpTitles = PopUpTitles;
  enumButtonName = Button;
  routePath = RoutePath;
  tabName = CurrentTab;

  // Static File/Template Paths & Constants
  sourceVendorPath = "../../../../assets/templete-file/SampleVendorListTemplate.xlsx";
  sourcePath = "../../../../assets/templete-file/SampleCompanyImport.xlsx";
  sourcePathCodecrosswalk = "../../../../assets/templete-file/SampleCodeCrosswalkImport.xlsx";
  sourcePathBom = "../../../../assets/templete-file/SampleRequirement.xlsx";
  fileName = "Sample Template.xlsx";

  // Instantiated Data Models & VMs
  importCompanyVM = new ImportCompanyVM();
  importModel = new ImportModel();
  insertUpdateImportDocumnets = new InsertUpdateImportDocumnets();

  // Dropdowns & Data Lists
  buyerRepList: CommonDropdownModel[] = [];
  salesPersonList: CommonDropdownModel[] = [];
  companyNameList: CommonDropdownModel[] = [];
  contactNameList: any[] = [];
  altSalePersonList = [];
  mappingTemplateList = [];
  sourcingTemplateList = [];

  // Active State, String, Number & File Variables
  file: File[] | null = null;
  base64OfFile: any;
  companyName: string | null = null;
  selectedMappingTemplateId: string = '';
  routeUrl!: string;
  currentTab!: string;
  headerText!: string;
  flexHeight: any;
  interval: any;

  // Boolean UI & Control Flags
  firstContainer: boolean = true;
  uploadSuccess: boolean = false;
  hideProgressbar: boolean = false;
  hideErrordiv: boolean = false;
  buttonDisabled: boolean = false;
  disabledContact: boolean = true;
  submit: boolean = false;
  emptyFile: boolean = false;
  headerValue: boolean = false;
  dataBlank: boolean = false;
  errorMessageSupported: boolean = false;
  fileNotMatchError: boolean = true;

  constructor(
    public companiesService: CompaniesService,
    public importDocumentsService: ImportDocumentsService,
    public toaster: ToastrService,
    public crmService: CrmService,
    private router: Router,
    public commonService: CommonService,
    private progressHelper: ProgressHelperService,
    public tabsService: TabsService,
    public codeCrosswalkService     :CodeCrosswalkService,
    public activityTabService : ActivityTabService
  ) { 
    this.routeUrl = this.router.url;
    this.tabsService.currentTab.subscribe(res => {
      if (res !== undefined) {
        this.currentTab = res;
      } 
    })
  }

  ngOnInit(): void {
    this.commonService.headerHeight.subscribe(res => {
      this.flexHeight = "calc(100vh - 266px - " + res + "px" + ")"

      if (this.routeUrl === this.routePath.IMPORTVENDOR_ROUTEPATH) {
        const width = window.innerWidth
        if (width <= 768) {
          this.flexHeight = "calc(70vh - 365px - " + res + "px)";
        }
      }
      if (this.routeUrl === this.routePath.CODECROSSWALK_ROUTEPATH) {
          this.flexHeight = "calc(100vh - 386px - " + res + "px)";
      }
    })
    this.crmService.getAllFilterDropDownList().subscribe(res => {
      this.salesPersonList = res.response.salesPersonList;
      this.buyerRepList = res.response.buyerRepList
      this.companyNameList = res.response.companyNameList;
      this.contactNameList = res.response.contactNameList;
    })
    this.fillList();
    this.crmService.sendImportId.subscribe((res) => {
    })
  }

  getSampleFilePath(): string {
    if (this.currentTab === this.tabName.CODECROSSWALK_TAB) {
      return this.sourcePathCodecrosswalk;
    }
    if (this.routeUrl === this.routePath.IMPORTVENDOR_ROUTEPATH) {
      return this.sourceVendorPath;
    }
    if (this.routeUrl === this.routePath.IMPORTBOM_ROUTEPATH) {
      return this.sourcePathBom;
    }
    return this.sourcePath;
  }

  upload(event: any) {
    if (event.target.files && event.target.files.length > 0) {
      this.readThis(event.target);
      this.file = event.target.files;
      this.errorMessageSupported = false;
      this.hideProgressbar = true;
      this.firstContainer = false;
      this.uploadSuccess = true;
    }
  }

  readThis(inputValue: any): void {
    var file: File = inputValue.files[0];
    this.insertUpdateImportDocumnets.templateData.fileName = file.name;
    var myReader: FileReader = new FileReader();

    myReader.onloadend = (e) => {
      this.base64OfFile = myReader.result;
      if(this.currentTab== this.tabName.CODECROSSWALK_TAB){
        this.insertUpdateImportDocumnets.importCodeCrosswalkModel.file = this.base64OfFile;
      }else if(this.routeUrl == this.routePath.IMPORTBOM_ROUTEPATH){
        this.insertUpdateImportDocumnets.importModel.file = this.base64OfFile;
      }else{
        this.insertUpdateImportDocumnets.importCompanyModel.file = this.base64OfFile;
      }
      this.checkingListAvailable(myReader.result)
      if (this.insertUpdateImportDocumnets.importCompanyModel.mappingTemplateId || this.insertUpdateImportDocumnets.importCodeCrosswalkModel.mappingTemplateId || this.insertUpdateImportDocumnets.importModel.mappingTemplateId) {
        this.checkingValidateFiles();
      }
    };
    myReader.readAsDataURL(file);
  }

  hideUploadingdiv() {
    this.file = null;
    this.hideErrordiv = true;
    this.hideProgressbar = false;
    clearInterval(this.interval);
  }

  showuploadedfile() {
    this.hideErrordiv = false;
    this.firstContainer = true;
  }

  newImport() {
    this.headerValue = false;
    this.uploadSuccess = false;
    this.firstContainer = true;
    this.file = null;
    this.fileNotMatchError = true;
    this.dataBlank = false;
    this.base64OfFile=''
    this.errorMessageSupported = false;
    if (this.currentTab === this.tabName.CODECROSSWALK_TAB) {
      this.insertUpdateImportDocumnets.importCodeCrosswalkModel.file = '';
    }
    else if (this.currentTab === this.tabName.IMPORT_BOM_TAB) {
      this.insertUpdateImportDocumnets.importModel.file = '';
    }
    else {
      this.insertUpdateImportDocumnets.importCompanyModel.file = '';
    }
  }

  closeTab(){
    if(this.routeUrl == this.routePath.IMPORTVENDOR_ROUTEPATH){
      this.importDocumentsService.closeVendorTab();
      this.router.navigate([this.routePath.VENDORLIST_ROUTEPATH]);
      this.tabsService.currentTab.next(this.tabName.VENDORLIST_TAB)
    }
    else if(this.routeUrl == this.routePath.IMPORTBOM_ROUTEPATH){
      this.importDocumentsService.closeBOMTab();
      this.router.navigate([this.routePath.REQUIREMENT_ROUTEPATH]);
      this.tabsService.currentTab.next(this.tabName.REQUIREMENTS_TAB)
    }
    else{
      this.importDocumentsService.closeTab();
      this.router.navigate([this.routePath.COMPANY_ROUTEPATH]);
      this.tabsService.currentTab.next(this.tabName.COMPANY_TAB)
    }
  }
 close(){ 
  this.codeCrosswalkService.valuePopup.next(true)
 }
  fillList() {
    this.importDocumentsService.getImportDropDownList().subscribe(res => {
      this.salesPersonList = res?.response?.salesPersonList;
      this.altSalePersonList = res?.response?.altSalesPersonList;
      this.contactNameList = res?.response?.companyNameList ;
      if(this.currentTab == this.tabName.CODECROSSWALK_TAB){
        this.insertUpdateImportDocumnets.mappingTemplateList = this.mappingTemplateList = res?.response?.sourcingTemplateList;
       }
       else if(this.routeUrl == this.routePath.IMPORTVENDOR_ROUTEPATH){
          this.insertUpdateImportDocumnets.mappingTemplateList = this.mappingTemplateList = res?.response?.vendorTemplateList;
       }
       else if(this.currentTab == this.tabName.IMPORT_BOM_TAB){
          this.insertUpdateImportDocumnets.mappingTemplateList = this.mappingTemplateList = res?.response?.requirementTemplateList;
       }
       else{
          this.insertUpdateImportDocumnets.mappingTemplateList = this.mappingTemplateList = res?.response?.mappingTemplateList;
        }
      this.buyerRepList = res?.response?.buyerRepList;
    })
  }

  showDescription() {
    if(this.currentTab == this.tabName.CODECROSSWALK_TAB){
      this.insertUpdateImportDocumnets.templateData.templateDescription = this.mappingTemplateList?.find(a => a?.id == this.insertUpdateImportDocumnets.importCodeCrosswalkModel.mappingTemplateId)?.description;
    }
    else if (this.currentTab === this.tabName.IMPORT_BOM_TAB) {
      this.insertUpdateImportDocumnets.templateData.templateDescription = this.mappingTemplateList?.find(a => a?.id == this.insertUpdateImportDocumnets.importModel.mappingTemplateId)?.description;
    }
    else{
      this.insertUpdateImportDocumnets.templateData.templateDescription = this.mappingTemplateList?.find(a => a?.id == this.insertUpdateImportDocumnets.importCompanyModel.mappingTemplateId)?.description;
    }
  }

  updateList() {
    this.importDocumentsService.getImportDropDownList().subscribe(res => {
      if(this.currentTab == this.tabName.CODECROSSWALK_TAB){
        this.insertUpdateImportDocumnets.mappingTemplateList = this.mappingTemplateList = res?.response?.sourcingTemplateList;
      }else{
        if(this.routeUrl == this.routePath.IMPORTVENDOR_ROUTEPATH){
          this.insertUpdateImportDocumnets.mappingTemplateList = this.mappingTemplateList = res?.response?.vendorTemplateList;
        }
        else if(this.routeUrl == this.routePath.IMPORTBOM_ROUTEPATH){
          this.insertUpdateImportDocumnets.mappingTemplateList = this.mappingTemplateList = res?.response?.requirementTemplateList;
        }
        else{
          this.insertUpdateImportDocumnets.mappingTemplateList = this.mappingTemplateList = res?.response?.mappingTemplateList;
        }
      }
    })
  }

  checkRequiredValue(): boolean {
    if(this.currentTab == this.tabName.CODECROSSWALK_TAB){
      if (this.file) {return true; }
       else {this.submit = true;}
    }
    else if(this.routeUrl == this.routePath.IMPORTVENDOR_ROUTEPATH){
      if(this.insertUpdateImportDocumnets.importCompanyModel.salesPersonId && this.file && this.insertUpdateImportDocumnets.importCompanyModel.buyersId) {
        return true;
      } else {this.submit = true; this.toaster.error('Fill Required Fields.');}
    } 
    else if (this.routeUrl == this.routePath.IMPORTBOM_ROUTEPATH) {
      if (this.insertUpdateImportDocumnets.importModel.salesPersonId && this.file && this.insertUpdateImportDocumnets.importModel.companyId) {
        return true;
      } else { this.submit = true; this.toaster.error('Fill Required Fields.'); }
    } 
    else {
      if (this.insertUpdateImportDocumnets.importCompanyModel.salesPersonId && this.file) {
        return true;
      } else { this.submit = true;  this.toaster.error('Fill Required Fields.');}
    }
  }

  navigateToMapTab() {
    if (this.buttonDisabled || this.errorMessageSupported) return;

    this.buttonDisabled = true;
    if (this.checkRequiredValue() && this.uploadSuccess && this.fileNotMatchError && !this.emptyFile  && !this.headerValue && !this.errorMessageSupported
    ) {
      this.progressHelper.eventHelper.next({ prev: false, next: true });
      let id =  this.currentTab == this.tabName.CODECROSSWALK_TAB?this.insertUpdateImportDocumnets.importCodeCrosswalkModel.mappingTemplateId : this.currentTab == this.tabName.IMPORT_BOM_TAB ? this.insertUpdateImportDocumnets.importModel.mappingTemplateId : this.insertUpdateImportDocumnets.importCompanyModel.mappingTemplateId
      if(!id){
        this.insertUpdateImportDocumnets.templateData = new TemplateData();
      }
      this.importDocumentsService.mapTabShow.next(true);
      if (!this.insertUpdateImportDocumnets.templateData.isTemplateCreate && !this.insertUpdateImportDocumnets.importCompanyModel.mappingTemplateId && this.selectedMappingTemplateId) {
        this.insertUpdateImportDocumnets.importCompanyModel.mappingTemplateId = this.selectedMappingTemplateId;
      }
      this.importDocumentsService.dataPassAccordingToTrackingBar.next(this.insertUpdateImportDocumnets);
    }
    this.buttonDisabled = false;
  
  }
  checkingValidateFiles() {
    let data;
    if(this.currentTab == this.tabName.CODECROSSWALK_TAB?
      this.insertUpdateImportDocumnets?.importCodeCrosswalkModel?.mappingTemplateId == "" 
      : this.currentTab == this.tabName.IMPORT_BOM_TAB ?
        this.insertUpdateImportDocumnets?.importModel?.mappingTemplateId == ""
      :this.insertUpdateImportDocumnets?.importCompanyModel?.mappingTemplateId == ""  
      || this.base64OfFile == ''){
     return;
     }else{
      data = { file: this.base64OfFile, templateId: this.currentTab == this.tabName.CODECROSSWALK_TAB ? this.insertUpdateImportDocumnets.importCodeCrosswalkModel.mappingTemplateId : this.currentTab == this.tabName.IMPORT_BOM_TAB ? this.insertUpdateImportDocumnets.importModel.mappingTemplateId : this.insertUpdateImportDocumnets.importCompanyModel.mappingTemplateId };
      this.importDocumentsService.validateFile(data)
        .pipe(
          catchError(async (err) => {
            console.error('Error validating template:', err);
            this.errorMessageSupported = true;
            this.headerText = 'Error! File upload is incompatible with the selected template.';
            this.fileNotMatchError = false;
            return null;
          })
        )
        .subscribe((res:Result) => {
          if (res) {
            if(res.isSuccess){
              this.fileNotMatchError = true;
              if (this.headerText === 'Error! File upload is incompatible with the selected template.') {
                this.headerText = '';
                this.errorMessageSupported = false;
              }
            }
            else {
              this.fileNotMatchError = false;
              this.errorMessageSupported = true;
              this.headerText = res.message || 'Error! File upload is incompatible with the selected template.';
            }
          }
        });
    }
  }
  
  handleError(err: any) {
    console.error('Error:', err);
    this.fileNotMatchError = false;
  }
  
  selectmappingTemplateId(event){
    this.selectedMappingTemplateId=event;
    if(this.currentTab == this.tabName.CODECROSSWALK_TAB){
      this.insertUpdateImportDocumnets.importCodeCrosswalkModel.mappingTemplateId=event
    } else if (this.routeUrl === this.routePath.IMPORTBOM_ROUTEPATH) {
      this.insertUpdateImportDocumnets.importModel.mappingTemplateId = event;
    } else {
      this.insertUpdateImportDocumnets.importCompanyModel.mappingTemplateId=event;
    }
  }

  checkingListAvailable(base64OfFile) {
    let data = { file: base64OfFile, sourceId: this.currentTab == this.tabName.CODECROSSWALK_TAB ? 3 : this.routeUrl == this.routePath.IMPORTVENDOR_ROUTEPATH ? 2 : this.routeUrl == this.routePath.IMPORTBOM_ROUTEPATH ? 9 : 1 }
    this.errorMessageSupported = false;
    this.headerText = '';
    this.importDocumentsService.validateFileHasData(data).pipe(
      catchError(async (err) => {
        console.error('Error validating file data:', err);
        this.errorMessageSupported = true;
        this.headerText = 'Error! Unsupported file type.';
        this.buttonDisabled = true;
        return null;
      })
    )
      .subscribe((res: Result) => {
        if (res) {
          if (res?.isSuccess) {
            if (res.message === "Error!! No record available in imported file.") {
              this.emptyFile = true;
              this.dataBlank = true;
              this.buttonDisabled = true;
              this.errorMessageSupported = true;
              this.headerText = res.message;
            } else if (res.message === "File invalid. Headers do not match the target headers.") {
              this.headerText = res.message;
              this.headerValue = true;
              this.buttonDisabled = true;
              this.errorMessageSupported = true;
            }
            else {
              this.headerValue = false;
              this.dataBlank = false;
              this.buttonDisabled = false;
              this.emptyFile = false;
              this.fileNotMatchError = true;
              this.errorMessageSupported = false;
              this.headerText = '';
              this.importDocumentsService.fileName.next(this.insertUpdateImportDocumnets?.templateData?.fileName);
            }
          }
          else if (!res?.isSuccess) {
            this.errorMessageSupported = true;
            this.headerText = res.message || 'Error! Unsupported file type.';
            this.buttonDisabled = true;
          }
        }
      });
  }

getmappingTemplateId():string{
  if(this.currentTab== this.tabName.CODECROSSWALK_TAB){
   return this.insertUpdateImportDocumnets.importCodeCrosswalkModel.mappingTemplateId;
  }else{
    return this.insertUpdateImportDocumnets.importCompanyModel.mappingTemplateId;
  }
  }
  selectValueChange(event) {
    this.companyName = event;
    this.disabledContact = !event;
    if (event === '' || event === 'No Records Found') {
      this.contactNameList = [];
      this.companyName = null;
      this.insertUpdateImportDocumnets.importModel.companyId = null;
      if (this.contactNameList.length == 0) {
        this.contactNameList.push({ id: null, name: "No Records Found" });
      }
    } else {
      this.contactNameList = [];
      this.getContactListById(event)
    }
  }
    getContactListById(id) {
    this.activityTabService.getContactList(id).subscribe((res) => {
      if (res.isSuccess) {
        this.contactNameList = res?.response?.contactList;
        if (this.contactNameList.length == 0) {
          const optionValue = { id: null, name: "No Records Found" };
          this.contactNameList.push(optionValue);
        }
      }
    })
  }
}
